





































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormBase, FormInput, FormSelect, FormTextarea, FormFile, FormError, FormSubmit } from "./parts";
import { isMobile } from "mobile-device-detect";

@Component({
    components: {
        FormBase,
        FormInput,
        FormSelect,
        FormTextarea,
        FormError,
        FormFile,
        FormSubmit
    }
})
export default class JobForm extends Vue {
    @Prop({ default: "" }) job!: string;
    @Prop({ default: "" }) formId?: string;

    termsAccepted = false;

    isMobile = isMobile;

    payload: any = {
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        statuut: "",
        motivation: "",

        zip: "",
        city: "",
        files: []
    };

    errorResponse: ErrorResponse = {
        status: 0,
        errors: []
    };

    success_message = "";

    private submit(form: FormClass) {
        if (!this.termsAccepted) {
            return;
        }

        this.success_message = "";
        const formData = new FormData();
        formData.append("method", "_POST");
        formData.append("email", this.payload.email);
        formData.append("first_name", this.payload.first_name);
        formData.append("last_name", this.payload.last_name);
        formData.append("phone", this.payload.phone);
        formData.append("motivation", this.payload.motivation);
        formData.append("job", this.job);
        formData.append("statuut", this.payload.statuut);
        // @ts-ignore
        formData.append("type", ["sm", "md", "lg"].includes(this.$root.$mq) ? "mobile" : "desktop");

        formData.append("zip", this.payload.zip);
        formData.append("city", this.payload.city);
        Object.values(this.payload.files).forEach((file: any) => {
            formData.append("files[]", file);
        });
        // @ts-ignore
        axios
            .post(`/api/forms/job-form`, formData)
            .then((response: any) => {
                // @ts-ignore
                if (window.hasOwnProperty("dataLayer") && dataLayer) {
                    // @ts-ignore
                    dataLayer.push({
                        event: "formSubmission",
                        formId: "2",
                        response: [
                            { name: "first_name", value: this.payload.first_name },
                            { name: "last_name", value: this.payload.last_name },
                            { name: "email", value: this.payload.email },
                            { name: "phone", value: this.payload.phone },
                            { name: "statuut", value: this.payload.statuut },
                            { name: "motivation", value: this.payload.motivation },
                            { name: "href", value: window.location.href },
                            { name: "pathname", value: window.location.pathname },

                            { name: "zip", value: this.payload.zip },
                            { name: "city", value: this.payload.city }
                        ]
                    });
                }
                this.termsAccepted = false;

                this.payload = {
                    email: "",
                    first_name: "",
                    last_name: "",
                    phone: "",
                    statuut: "",
                    motivation: "",

                    zip: "",
                    city: "",
                    files: []
                };
                this.success_message = "Yep, die zit in onze mailbox. Bedankt voor je sollicitatie, en we contacteren je binnen de week!";

                this.errorResponse = {
                    status: 0,
                    errors: []
                };
            })
            .catch((e: { response: { data: ErrorResponse } }) => {
                this.errorResponse = e.response.data;
            })
            .finally(() => {
                form.reset();
            });
    }
}
